var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBlackPlusIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7H14",
    stroke: "#002852"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 0L7 14",
    stroke: "#002852"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBlackPlusIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/black_plus_icon.a61eb07bf571356729564171b60917cc.svg";